import { render, staticRenderFns } from "./ClinicGallery.vue?vue&type=template&id=98cf4582"
import script from "./ClinicGallery.vue?vue&type=script&lang=js"
export * from "./ClinicGallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports